module.exports = __webpack_public_path__ + "static/media/Skin_tone_2.97bcee7b.svg";